import { getApps, initializeApp } from 'firebase/app'

import {
  getFirestore as getFs,
  connectFirestoreEmulator,
} from 'firebase/firestore'
import {
  getStorage as getStore,
  connectStorageEmulator,
} from 'firebase/storage'
import { getAuth as getAuthOriginal, connectAuthEmulator } from 'firebase/auth'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGE_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
}

export function initialize() {
  //check if there is already a firebase app
  const apps = getApps()
  let app
  if (apps.length > 0) {
    app = apps[0]
  } else {
    app = initializeApp(firebaseConfig)
  }

  if (import.meta.env.VITE_USE_EMULATORS === 'true') {
    const auth = getAuthOriginal()
    console.log('connecting to test auth')
    connectAuthEmulator(
      auth,
      'http://' + import.meta.env.VITE_DEV_HOSTNAME + ':9099',
    )
    const db = getFs()
    if (import.meta.env.VITE_USE_EMULATORS === 'true') {
      console.log('connecting to test database')
      connectFirestoreEmulator(db, import.meta.env.VITE_DEV_HOSTNAME, 8080)
    }
    const storage = getStore()
    if (import.meta.env.VITE_USE_EMULATORS === 'true') {
      connectStorageEmulator(storage, import.meta.env.VITE_DEV_HOSTNAME, 9199)
    }
  }
  return app
}

export function getAuth() {
  const auth = getAuthOriginal()
  return auth
}

export function getFirestore() {
  const db = getFs()
  return db
}

export function getStorage() {
  const storage = getStore()
  return storage
}

// Firebase-dependent helper functions
import { z } from 'zod'
import { Timestamp } from 'firebase/firestore'
import { BundleModelFactory } from 'monocle-models'

export const { BundleDBModel } = new BundleModelFactory(Timestamp)

// Use a type parameter with constraints for the bundle shape
export const filterBundles = (
  bundles: z.infer<typeof BundleDBModel>[],
  searchTerm: string,
) => {
  //if there is no search term, return all bundles
  if (!searchTerm) {
    return bundles
  } else {
    return bundles.filter((bundle) => {
      return bundle.owner_editable.details.title
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase())
    })
  }
}
